import React, { useState, Suspense, lazy } from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
    Card,
    Image,
    Text,
    Group,
    Badge,
    createStyles,
    Center,
    Button,
    ActionIcon,
    Paper,
    Modal
} from '@mantine/core';
import {
    IconGavel,
    IconHourglass,
    IconHeartPlus,
    IconHeart,
    IconEye,
    IconBell,
    IconMovie,
    IconPhoto,
    IconVideoPlus,
    IconAlarm,
    IconCalendar,
    IconUsers,
    IconMapPin,
    IconMessage
} from '@tabler/icons';

import { CarCardDetsScoreCard } from '../components/CarCardDetsScoreCard';
import { BidsCommentsTabNav } from '../components/BidsCommentsTabNav';
import { CarCardDetsTabNavA } from '../components/CarCardDetsTabNavA';

//overlays
import { MultiMediaGallery } from '../components/MultiMediaGallery';
import { AlertMeCard } from '../components/AlertMeCard';
import { SchedulerCard } from '../components/SchedulerCard';
import PlaceBid from '../components/PlaceBid';

import pagani from '../assets/pagani.jpg'
const useStyles = createStyles((theme) => ({
    cardContain: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,    
        width: '95%'
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /*borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,*/
    },
    
    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        letterSpacing: -0.25,
        textTransform: 'uppercase',
    },
    section: {
        padding: theme.spacing.md,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    subSection: {
        borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    icon: {
        marginRight: 5,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
    defWidth: {
        width: '60%'
    },
    coverImage: {
        width: "fill",
        paddingBottom: "5px"
    },
    mediaGalleryBtns: {
        width: '70%',
        margin: '0 auto'
    },
    specialMsg: {
        backgroundColor: 'grey',
    },
    timeLeftWidth: {
        width: '80%',
        marginLeft: '3%',
        margin: '0 auto'
    },
    listingTitle: {
        textAlign: "center"
    }
}));

/*
 * Sections needed for full dets
 * fill with dummy data
 * (handle if the user decided )
 * cover photo
 * CarCardDetsMediaGallery -> id="mediaGallerySection"(next layer)
 * CarCardDetsScoreCard*
 *  - bid
 *  - timeleft
 *  - ending
 *  - bids
 *  - views
 *  - location
 * CarCardDetsSpecialMsg*
 * CarCardDetsCarDets(here)
 *  - (make this a table inside a card)
 * CarCardDetsArticle*
 *  - (consisits of paragraphs and images)
 * custom text sections and bullet points section
 *  - make it just like the links section
 * comment Section*
 * CarCardDetsBidSection(needs created)*
 *  - username
 *  - timestamp
 *  - amount
 * */

//of_note: may want to make this into CarCreationPreview
//needed:props to be passed
    //- [ ] props
    //- [ ]  modals
        // - [ ]  gallery
        // - [ ]  alert me
        // - [ ]  schedule a meeting
    //- [ ]  empty section placeholders
        // - [ ]  comments
        // - [ ]  bids
    // - [ ]   bullet-point list crud (ref video embedding)
        
    //- scrollTo

//map to redux for handling sse events
/*export function CarCardDets({
    title_0,
    current_bid_0,
    end_date_4,
    bid_cnt_1,
    item_views_1,
    location_0,
    comment_cnt_1,
    my_take_0,

}) {*/
export function CarCardDets() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  
  

    return (
        <>
            <h1 className={classes.listingTitle}>
            2015 Pagani Huayra Mint Condition Barely Used
            </h1>
            <Card shadow="sm" p="lg" radius="md" className={classes.cardContain} withBorder>
                <Card.Section>
                    <Image
                        src={pagani}
                        className={classes.coverImage}
                        height={360}
                        width={"fill"}
                    />
                </Card.Section>
                <Card.Section>
                    <Group id="mediaGallerySection" position="apart" className={classes.mediaGalleryBtns}>
                        <ActionIcon variant="transparent" size="lg">
                            <IconPhoto color={"black"} size={55} stroke={2.0}/>
                        </ActionIcon>
                        <ActionIcon variant="transparent" size="lg">
                            <IconBell color={"black"} size={55} stroke={2.0}/>
                        </ActionIcon>
                        <ActionIcon variant="transparent" size="lg">
                            <IconVideoPlus color={"black"} size={55} stroke={2.0}/>
                        </ActionIcon>
                    </Group>
                </Card.Section>
            </Card>
            <br/>
            <Button
                fullWidth
                leftIcon={<IconGavel color={"white"} size={35} stroke={2.0}/>}
                color={"blue"}
            >
            PLACE BID
            </Button>
            
            
            
            
            
            <Card shadow="sm" p="lg" radius="md" withBorder className={classes.cardContain}>
                <Card.Section>
                    <h1>$95,000</h1>
                </Card.Section>
                <Card.Section>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Time Left</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconAlarm color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            8 days
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Ending</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconCalendar color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            Tue, Jan 03
                            </Text>
                        </Group>
                        <br/>
                        <Text fw={500}>
                            1:30PM (PST)
                        </Text>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Bids</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconUsers color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            15
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Views</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconEye color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            125
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Location</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconMapPin color={"black"} size={20} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            Pitt., PA
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Comments</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconMessage color={"black"} size={20} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            150
                            </Text>
                        </Group>
                    </Group>
                </Card.Section>
            </Card>
            
            
            
            {/*do we use state or params???????????*/}
            <CarCardDetsTabNavA />
            
            <Paper shadow="xs" p="md" className={classes.defWidth,classes.specialMsg}>
                <Text>
                Sed blandit non sapien a lacinia. Nunc eu ornare leo. Aliquam eget tellus velit. Nam ac nisi ac sapien accumsan viverra. Quisque feugiat ultrices mauris sed egestas. Nulla ex leo, elementum et euismod vitae, tincidunt eu justo. Pellentesque vitae leo dui. Sed in nisi ornare, fringilla sem id, sagittis dolor.
                </Text>
            </Paper>
            <br/>
            
            <br/>
            
            <BidsCommentsTabNav />
        </>
    );
}
